export const LOAD_ANIMATED_THUMBNAIL_DATA = Symbol('LOAD_ANIMATED_THUMBNAIL_DATA');
export const ADD_ANIMATED_THUMBNAIL_DATA = Symbol('ADD_ANIMATED_THUMBNAIL');

export const loadAnimatedThumbnailDataAction = (videoId) => ({
  type: LOAD_ANIMATED_THUMBNAIL_DATA,
  payload: {
    videoId,
  },
});

export const addAnimatedThumbnailAction = (videoId, storyboard) => ({
  type: ADD_ANIMATED_THUMBNAIL_DATA,
  payload: {
    videoId,
    storyboard,
  },
});
